import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

interface OutlinedCardProps {
  nome: string;
  valor: string;
  cor: string;
  onClick?: () => void;
}

const OutlinedCard01: React.FC<OutlinedCardProps> = ({ nome, valor, cor, onClick }) => {
  return (
    <Card
      variant="outlined"
      onClick={onClick}
      sx={{
        height: '100%',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        '&:hover': onClick ? { boxShadow: 4, transform: 'translateY(-2px)' } : undefined,
      }}
    >
      <CardContent sx={{ display: 'flex', alignItems: 'stretch', gap: 1.25, py: 1.5, px: 1.75, '&:last-child': { pb: 1.5 } }}>
        <Box
          sx={{
            width: 4,
            borderRadius: 4,
            backgroundColor: cor,
            flexShrink: 0,
          }}
        />
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            sx={{ display: 'block', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.3 }}
          >
            {nome}
          </Typography>
          <Typography
            variant="h6"
            noWrap
            sx={{ fontWeight: 700, mt: 0.25 }}
          >
            {valor}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default OutlinedCard01;
